import { Error } from './Error';

export const UnauthorizedError = () => {
  return <Error title={'401'} subtitle={'Unauthorized!'} />;
};
